import React from 'react';
import PropTypes from 'prop-types';

import CardCompanyProfileAvatar from '@atoms/CardCompanyProfileAvatar';
import { BodyMedium, PatternLightStyled, DivWithShadowAlternate, H4 } from '@styled';

import colors from '@general/colors';
import useCompanyFull from '@hooks/useCompanyFull';

const CompanyProfileCard = ({ graphID }) => {
    const { data } = useCompanyFull(graphID);

    if (!data) return null;

    const getSecondaryBusinessNames = secondaryBusinessTypes => {
        if (!secondaryBusinessTypes || !secondaryBusinessTypes.length) {
            return false;
        }
        return secondaryBusinessTypes.map(type => (type.name.includes('-') ? type.name.split('-')[1] : type.name));
    };
    const secondaryBusinessNames = getSecondaryBusinessNames(data?.secondaryBusinessTypes);

    return (
        <DivWithShadowAlternate style={{ width: '100%' }}>
            <PatternLightStyled style={{ height: '100%' }}>
                <div className="align-items-center d-flex justify-content-center mb-2rem">
                    <CardCompanyProfileAvatar
                        photoURL={data.logoUrl}
                        companyName={data.name}
                        sizeMobile={100}
                        sizeDesktop={182}
                    />
                </div>
                <H4 className="mb-1rem text-center">{data.name}</H4>

                <BodyMedium className="text-center">
                    {data?.primaryBusinessType.name && (
                        <span style={{ color: colors.background, display: 'block', marginBottom: '.2rem' }}>
                            {data.primaryBusinessType.name}
                        </span>
                    )}
                    {secondaryBusinessNames &&
                        secondaryBusinessNames.map(businessName => (
                            <span
                                style={{
                                    color: colors.background,
                                    display: 'block',
                                    marginBottom: '.3rem',
                                    fontSize: '0.9rem',
                                    lineHeight: '1.3',
                                }}
                                key={businessName}
                            >
                                {businessName}
                            </span>
                        ))}
                </BodyMedium>
            </PatternLightStyled>
        </DivWithShadowAlternate>
    );
};

CompanyProfileCard.propTypes = {
    graphID: PropTypes.string,
};

export default CompanyProfileCard;
